import { VIEW_COLUMNS } from './columns';
import { QUICK_FILTERS, VIEW_FILTERS } from './filters';
import { formatColumnSettingsStorage } from './helpers';

export const INVENTORY_ATS_COLUMNS_DEFAULT_ORDER = [
  VIEW_COLUMNS.PRODUCT_NAME.id,
  VIEW_COLUMNS.SKU.id,
  VIEW_COLUMNS.UPC.id,
  VIEW_COLUMNS.QTY.id,
  VIEW_COLUMNS.AVAILABLE_TO_SELL.id,
  VIEW_COLUMNS.SHIP_TYPES.id,
  VIEW_COLUMNS.LEAD_TIME.id,
  VIEW_COLUMNS.COST.id,
  VIEW_COLUMNS.TOTAL_COST.id,
  VIEW_COLUMNS.PRICE.id,
  VIEW_COLUMNS.TOTAL_PRICE.id,
];

export const INVENTORY_ATS_COLUMNS = {
  [VIEW_COLUMNS.PRODUCT_NAME.id]: {
    ...VIEW_COLUMNS.PRODUCT_NAME,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '250px',
    },
  },
  [VIEW_COLUMNS.SKU.id]: {
    ...VIEW_COLUMNS.SKU,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '250px',
    },
  },
  [VIEW_COLUMNS.UPC.id]: {
    ...VIEW_COLUMNS.UPC,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '180px',
    },
  },
  [VIEW_COLUMNS.QTY.id]: {
    ...VIEW_COLUMNS.QTY,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '180px',
    },
  },
  [VIEW_COLUMNS.AVAILABLE_TO_SELL.id]: {
    ...VIEW_COLUMNS.AVAILABLE_TO_SELL,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '100px',
    },
  },
  [VIEW_COLUMNS.SHIP_TYPES.id]: {
    ...VIEW_COLUMNS.SHIP_TYPES,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: true,
    cellProps: {
      align: 'left',
      minWidth: '180px',
    },
  },
  [VIEW_COLUMNS.LEAD_TIME.id]: {
    ...VIEW_COLUMNS.LEAD_TIME,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '180px',
    },
  },
  [VIEW_COLUMNS.COST.id]: {
    ...VIEW_COLUMNS.COST,
    enabled: true,
    sortable: false,
    filterableContextMenu: false,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '250px',
    },
  },
  [VIEW_COLUMNS.TOTAL_COST.id]: {
    ...VIEW_COLUMNS.TOTAL_COST,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '125px',
    },
  },
  [VIEW_COLUMNS.PRICE.id]: {
    ...VIEW_COLUMNS.PRICE,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '100px',
    },
  },
  [VIEW_COLUMNS.TOTAL_PRICE.id]: {
    ...VIEW_COLUMNS.TOTAL_PRICE,
    enabled: true,
    sortable: true,
    filterableContextMenu: true,
    copyable: true,
    editable: false,
    cellProps: {
      align: 'left',
      minWidth: '180px',
    },
  },
};

export const INVENTORY_ATS_FILTERS = {
  ...VIEW_FILTERS,
};

export const INVENTORY_ATS_COLUMNS_STORAGE_SETTINGS = formatColumnSettingsStorage(
  INVENTORY_ATS_COLUMNS,
);

export const INVENTORY_ATS_QUICK_FILTERS = [
  ...QUICK_FILTERS,
];